import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import { ReadContractorsPlannedHoursApproval } from "@/types/contractorsPlannedHoursApproval";

export const ContractorsPlannedHoursApprovalsService =
  new APIService<ReadContractorsPlannedHoursApproval>(
    API.ContractorsPlannedHoursApprovals,
  );
